export function typedEntries<T extends object>(obj: T) {
  return Object.entries(obj) as Array<[keyof T, NonNullable<T[keyof T]>]>
}
